<template>
  <div>
    <div v-if="minMode"
         class="status-min-wrapper"
    >
      <v-icon left :style="{color: status.color}">{{status.icon}}</v-icon>
      <b class="text" :style="{color: status.color}">{{status.title}}</b>
    </div>

    <div v-else
         class="status-wrapper"
         :style="{backgroundColor: status.color}"
    >
      <v-icon left>{{status.icon}}</v-icon>
      <span class="text">{{status.title}}</span>
    </div>
  </div>
</template>

<script>
import Statuses from '@/services/statuses'

export default {
  name: 'BuyoutStatus',
  computed: {
    status: function () {
      return  Statuses.getStatuses()[this.statusId]
    }
  },
  props: {
    minMode: {
      default: false,
      type: Boolean
    },
    statusId: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped>

</style>